import Experiments from '@wix/wix-experiments';

interface ConductExperimentParams {
  key: string;
  scope: string;
}

export const conductExperiment = async ({
  key,
  scope,
}: ConductExperimentParams): Promise<boolean> => {
  const experiments = new Experiments({
    scope,
  });
  await experiments.ready();
  return experiments.enabled(key);
};
